<div class="modalWrapper">
  <div class="modal">
    <a class="close" (click)="onClose()"><span>Cerrar</span></a>
    <h3>Ingresa tus credenciales de Diro</h3>
    <form [formGroup]="form">
      <div class="modalContent">
        <div class="inputWrapper">
          <input type="text" placeholder="User Id " formControlName="mail" maxlength="100" />
          <input type="password" placeholder="Password" formControlName="password" maxlength="100" />
        </div>
      </div>
    </form>
    <div class="modalActions">
      <button (click)="onClose()" class="secondary">Cancel</button>
      <button [disabled]="!isEnabled" (click)="onLogin()">Ingresar</button>
    </div>
  </div>
</div>